"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletConnectionManager = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var useWallet_1 = require("../hooks/useWallet");
/**
 * Render props component for managing wallet connections
 *
 * This component provides a render props pattern for easily creating
 * custom wallet connection UIs without being prescriptive about design.
 *
 * @param props WalletConnectionManagerProps
 * @returns Rendered children with connection state and actions
 */
var WalletConnectionManager = function (_a) {
    var children = _a.children;
    var _b = (0, useWallet_1.useWallet)(), wallet = _b.wallet, publicKey = _b.publicKey, connecting = _b.connecting, connected = _b.connected, select = _b.select, connect = _b.connect, disconnect = _b.disconnect;
    var handleSelectWallet = (0, react_1.useCallback)(function (name) {
        select(name);
    }, [select]);
    var connectionInfo = {
        connecting: connecting,
        connected: connected,
        publicKey: (publicKey === null || publicKey === void 0 ? void 0 : publicKey.toBase58()) || null,
        walletName: (wallet === null || wallet === void 0 ? void 0 : wallet.adapter.name.toString()) || null,
        walletIcon: (wallet === null || wallet === void 0 ? void 0 : wallet.adapter.icon) || null,
        connect: connect,
        disconnect: disconnect,
        selectWallet: handleSelectWallet,
    };
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children(connectionInfo) });
};
exports.WalletConnectionManager = WalletConnectionManager;
